/**
 * Regra do botão "limpar" da FilterBar (só tags — visibilidade vem de catalogSettings).
 */
export function shouldShowClearFilter({
  hasRealAccess,
  prefilterByTagFirst,
  didUserSelectFilter,
  selectedFilter,
  isAdmin,
}) {
  if (isAdmin && selectedFilter !== null) return true;
  if (!selectedFilter) return false;
  if (hasRealAccess) {
    return didUserSelectFilter || prefilterByTagFirst;
  }
  return didUserSelectFilter;
}
